
<template>

  <div class="ui inverted primary segment" :style="{ display: quarters[0] ? 'block' : 'none' }">
    <div class="ui centered grid">

      <div class="row">
        <h2 class="ui almarai yellow header">
          أرباع الأحزاب: {{ quarters.length }}
        </h2>
      </div>

      <!-- Participate button -->
      <div class="row">
        <div class="column">
          <button class="ui fluid yellow button" @click="participate()">
            <span class="ui almarai large text">شارك</span>
          </button>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import axios from 'axios';

export default {

  name: 'Participation',
  props: {

    khatma: Object,
    quarters: Array

  },
  methods: {

    async participate() {

      if (confirm(`أشارك بهذه الختمة وأهدي ثوابها إلى ${this.khatma.ehdaa} وجميع المشاركين بالختمة وموتاهم`)) {

        try {

          const result = await axios.put(`${process.env.VUE_APP_BASE_URL}/khatmat/${this.khatma.id}`, {

            quarters: this.quarters

          });

          if (result.data.khatmaResult.changes[0].new_val.progress === 0)
            this.$socket.emit('currentKhatmaCompleted');

          this.$gtag.event('Participate', {

            event_category: 'Khatmat',
            event_label: this.khatma.ehdaa,
            value: this.quarters.length

          });

          localStorage.setItem('khatmaID', this.khatma.id);
          localStorage.setItem('ehdaa', this.khatma.ehdaa);
          localStorage.setItem('selectedQuarters', JSON.stringify(result.data.quartersResult.changes.map((change) => change.new_val)));

          window.location.replace('/khatmat/result');

        } catch (err) {

          alert('انتهت صلاحية الصفحة');
          window.location.reload();

        }

      }

    }

  }

}
</script>

<style scoped>
.segment {
  position: sticky !important;
}

button {
  touch-action: manipulation;
}
</style>
